var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowLeftLong = function SvgArrowLeftLong(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Documents-Create-Question-1---Overview-left---Questions/answers-list",
    transform: "translate(-25.000000, -94.000000)",
    fill: "#001640",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34.000000, 102.433333) rotate(-180.000000) translate(-34.000000, -102.433333) translate(26.000000, 95.933333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,5.4 C14.9522847,5.4 15.4,5.84771525 15.4,6.4 C15.4,6.91283584 15.0139598,7.33550716 14.5166211,7.39327227 L14.4,7.4 L-4.85611551e-13,7.4 C-0.55228475,7.4 -1,6.95228475 -1,6.4 C-1,5.88716416 -0.61395981,5.46449284 -0.116621125,5.40672773 L-4.85611551e-13,5.4 L14.4,5.4 Z",
    id: "Line-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09289322,-0.707106781 C8.45337718,-1.06759074 9.02060824,-1.09532028 9.41289944,-0.790295388 L9.50710678,-0.707106781 L15.9071068,5.69289322 C16.2675907,6.05337718 16.2953203,6.62060824 15.9902954,7.01289944 L15.9071068,7.10710678 L9.50710678,13.5071068 C9.11658249,13.8976311 8.48341751,13.8976311 8.09289322,13.5071068 C7.73240926,13.1466228 7.70467972,12.5793918 8.00970461,12.1871006 L8.09289322,12.0928932 L13.785,6.4 L8.09289322,0.707106781 C7.73240926,0.34662282 7.70467972,-0.220608236 8.00970461,-0.612899443 L8.09289322,-0.707106781 Z",
    id: "Path-5"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeftLong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left-long.ff862f3f.svg";
export { ForwardRef as ReactComponent };